// extracted by mini-css-extract-plugin
export default {"rounded":"PopUpLogin_rounded__OQ5xF"};